import request from 'utils/request';

/**
 * Export entity by id.
 */
export const exportEntityById = id => request.get(`/exports/${id}`, { id });
